import { useTranslator } from 'tradera-lang/translate';
import React from 'react';
import triot from 'triot';

export const ReplyButton = ({ feedbackItem }) => {
    const { t } = useTranslator();

    const onClick = () => {
        const payload = {
            modalTitle: t('profileRating_commentReview'),
            itemId: feedbackItem.itemId,
            gradeId: feedbackItem.gradeId,
            itemDescription:
                feedbackItem.itemId + ' - ' + feedbackItem.itemDescription,
            commentRating: feedbackItem.rating.toLowerCase(),
            commentText: feedbackItem.text,
            commentCreated: feedbackItem.createdAgo,
            commentRole: feedbackItem.feedBackMemberRoleDescription,
            receiverMemberAlias: feedbackItem.feedbackMemberAlias,
            receiverMemberId: feedbackItem.feedbackMemberId
        };

        triot.bus.trigger('ui:contact-modal:show-modal', payload);
    };

    return (
        <button className="btn btn-primary" onClick={onClick}>
            {t('profileRating_createComment')}
        </button>
    );
};
